import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from 'components/common/Elements/Elements';

import classes from './BtnPurpleCircle.module.scss';

const BtnPurpleCircle = ({ icon, onClick, className, type = 'button' }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cn(classes.btnPurpleCircle, className)}
    >
      <Icon
        icon={icon}
        className={icon === 'Icn_Share' ? classes.iconShare : classes.icon}
      />
    </button>
  );
};

BtnPurpleCircle.propTypes = {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string
};

export default BtnPurpleCircle;
